import axios, { AxiosResponse } from "axios";
import { BaseResponse } from "../../common/interfaces/responses";
import { get200ErrorMsg, getErrorMsg } from "../../common/utils/request";
import {
	CommentListResponse,
	FetchCommentOpts,
	LikeCommentResponse,
	SubmitCommentOpts,
	SubmitCommentResponse,
} from "../interfaces/http";

declare var pm: PmInterface;

export const fetchAllComments = async (
	opts: FetchCommentOpts,
): Promise<CommentListResponse> => {
	const formData = new FormData();

	formData.append("action", opts.action);
	formData.append("nonce", opts.nonce);
	formData.append("post_id", opts.photoId.toString());

	try {
		const axiosResponse: AxiosResponse<any> = await axios({
			method: "post",
			url: pm.ajaxurl,
			data: formData,
		});

		if (!axiosResponse.data || !axiosResponse.data.success) {
			return {
				success: false,
				message: get200ErrorMsg(axiosResponse),
				data: [],
			};
		}

		return axiosResponse.data;
	} catch (response: any) {
		return {
			success: false,
			message: getErrorMsg(response),
			data: [],
		};
	}
};

export const deleteComment = async (id: number): Promise<BaseResponse> => {
	const formData = new FormData();

	formData.append("action", "pm_delete_comment");
	formData.append("nonce", pm.nonces.deleteComment);
	formData.append("comment_id", id.toString());

	try {
		const axiosResponse: AxiosResponse<any> = await axios({
			method: "post",
			url: pm.ajaxurl,
			data: formData,
		});

		if (!axiosResponse.data || !axiosResponse.data.success) {
			return {
				success: false,
				message: get200ErrorMsg(axiosResponse),
			};
		}

		return {
			success: true,
			message: axiosResponse.data.data,
		};
	} catch (response: any) {
		return {
			success: false,
			message: getErrorMsg(response),
		};
	}
};

export const likeComment = async (
	id: number,
	actionType: string,
): Promise<LikeCommentResponse> => {
	const formData = new FormData();

	formData.append("action", "pm_like_comment");
	formData.append("nonce", pm.nonces.likeComment);
	formData.append("comment_id", id.toString());
	formData.append("action_type", actionType);

	try {
		const axiosResponse: AxiosResponse<any> = await axios({
			method: "post",
			url: pm.ajaxurl,
			data: formData,
		});

		if (!axiosResponse.data || !axiosResponse.data.success) {
			return {
				success: false,
				message: get200ErrorMsg(axiosResponse),
			};
		}

		return {
			success: true,
			message: axiosResponse.data.data.message,
			totalLikes: axiosResponse.data.data.totalLikes,
		};
	} catch (response: any) {
		return {
			success: false,
			message: getErrorMsg(response),
		};
	}
};

export const submitComment = async (
	opts: SubmitCommentOpts,
): Promise<SubmitCommentResponse> => {
	const formData = new FormData();

	formData.append("action", opts.action);
	formData.append("nonce", opts.nonce);
	formData.append("post_id", opts.postId.toString());
	formData.append("parent_id", opts.parentId.toString());
	formData.append("content", opts.content);

	try {
		const axiosResponse: AxiosResponse<any> = await axios({
			method: "post",
			url: pm.ajaxurl,
			data: formData,
		});

		if (!axiosResponse.data || !axiosResponse.data.success) {
			return {
				success: false,
				message: get200ErrorMsg(axiosResponse),
			};
		}

		return axiosResponse.data;
	} catch (response: any) {
		return {
			success: false,
			message: getErrorMsg(response),
		};
	}
};
